import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=218fa258&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('218fa258')) {
      api.createRecord('218fa258', component.options)
    } else {
      api.reload('218fa258', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=218fa258&", function () {
      api.rerender('218fa258', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8RWzUnBTxZfWp/JS/offershelp.vue"
export default component.exports